import { render, staticRenderFns } from "./MbFile.vue?vue&type=template&id=1c95352d&scoped=true&"
import script from "./MbFile.vue?vue&type=script&lang=js&"
export * from "./MbFile.vue?vue&type=script&lang=js&"
import style0 from "./MbFile.vue?vue&type=style&index=0&id=1c95352d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95352d",
  null
  
)

export default component.exports